module.exports = __webpack_public_path__ + "img/sybg.2690f5cd.jpg";